module.exports = __webpack_public_path__ + "img/d2x16__gb91.prt.0635c65f.jpg";